if (process.env.NODE_ENV === "production") {
  module.exports = "div"
} else {
  module.exports = require("./devTools.dev")
}
